import { errors } from "com";
import { MENUS_ENDPOINTS } from "./endpoints";
import type { SaveMenuPayload, SaveMenuResponse } from "./types";
import { apiRequestWithData } from "../shared";

const { ValidationError } = errors;

function validateMenuPayload(payload: SaveMenuPayload): void {
  if (!payload || typeof payload !== "object") {
    throw new ValidationError("Menu payload must be an object");
  }
  if (!payload.week_start) throw new ValidationError("week_start is required");
  if (payload.version !== undefined && typeof payload.version !== "string") {
    throw new ValidationError("version must be a string");
  }
  if (!Array.isArray(payload.items)) throw new ValidationError("items must be an array");
  if (payload.items.length === 0) throw new ValidationError("items array cannot be empty");
}

export default async function saveWeeklyMenu(payload: SaveMenuPayload): Promise<SaveMenuResponse["data"]> {
  validateMenuPayload(payload);
  return apiRequestWithData<SaveMenuResponse["data"]>(MENUS_ENDPOINTS.SAVE, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

